import { render, staticRenderFns } from "./xcxLink.vue?vue&type=template&id=5ae0728d"
import script from "./xcxLink.vue?vue&type=script&lang=js"
export * from "./xcxLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports